
<div class="flex min-h-screen items-center justify-center bg-slate-100 p-4">
  <div class="w-full max-w-md">

    @if(isLoggedInButNotReviewer()) {
      <!-- ACCESS DENIED STATE -->
      <div class="bg-white shadow-lg rounded-xl px-8 pt-6 pb-8 mb-4">
        <div class="mb-8 text-center">
          <svg class="mx-auto h-12 w-12 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
          </svg>
          <h1 class="text-2xl font-bold text-slate-800 mt-4">Access Denied</h1>
          <p class="text-slate-500 mt-2">
            You have successfully signed in, but your account does not have permission to access this application.
          </p>
          <p class="text-left text-slate-600 text-sm mt-6 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
            <strong>Action Required:</strong> Please contact an administrator. They need to add the following flag to your user metadata in the Supabase "Auth &gt; Users" section:
            <code class="block bg-slate-200 text-slate-800 p-2 rounded mt-2 text-xs">
              {{ '{' }} "onboard_reviewer": true {{ '}' }}
            </code>
          </p>
        </div>
        <button 
            (click)="handleLogout()" 
            [disabled]="loading()"
            class="w-full bg-slate-600 hover:bg-slate-700 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-150 ease-in-out disabled:bg-slate-400 flex items-center justify-center">
            @if(loading()) {
              <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Signing out...</span>
            } @else {
              <span>Sign Out</span>
            }
        </button>
      </div>

    } @else {
      <!-- DEFAULT LOGIN STATE -->
      <div class="bg-white shadow-lg rounded-xl px-8 pt-6 pb-8 mb-4">
        @if (otpSent()) {
          <!-- OTP ENTRY STATE -->
          <div class="text-center">
             <svg class="mx-auto h-12 w-12 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m21.75 0-9 6.75L2.25 6.75m21.75 0-9 6.75m-9-6.75h18" />
            </svg>
            <h1 class="text-2xl font-bold text-slate-800 mt-4">Check your email</h1>
            <p class="text-slate-500 mt-2">A 6-character code has been sent to <strong>{{ email() }}</strong>.</p>
          </div>

          @if(error()) {
            <div class="bg-red-50 text-red-800 p-3 rounded-md flex items-center my-4 text-sm" role="alert">
              <svg class="h-5 w-5 text-red-500 mr-3 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.293 7.293a1 1 0 011.414 0L10 8.586l1.293-1.293a1 1 0 111.414 1.414L11.414 10l1.293 1.293a1 1 0 01-1.414 1.414L10 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L8.586 10 7.293 8.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
              <span>{{ error() }}</span>
            </div>
          }

          <form (ngSubmit)="handleOtpSubmit()" class="mt-8">
            <div class="space-y-4">
              <div>
                <label for="otp" class="sr-only">6-character code</label>
                <input 
                  #otpInput
                  type="text" 
                  id="otp" 
                  name="otp"
                  [(ngModel)]="otp"
                  required
                  maxlength="6"
                  minlength="6"
                  placeholder="123456"
                  inputmode="numeric"
                  pattern="[0-9]{6}"
                  autocomplete="one-time-code"
                  class="block w-full rounded-md border-0 py-2.5 text-center text-lg text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6" />
              </div>
              <button 
                type="submit"
                [disabled]="loading() || otp().length !== 6"
                class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-150 ease-in-out disabled:bg-slate-400 flex items-center justify-center">
                @if(loading()) {
                  <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Verifying...</span>
                } @else {
                  <span>Verify Code</span>
                }
              </button>
              <button (click)="goBack()" type="button" class="w-full text-center text-sm text-slate-600 hover:text-indigo-600 transition-colors">
                Use a different email
              </button>
            </div>
          </form>

        } @else {
          <!-- EMAIL ENTRY STATE -->
          <div class="mb-8 text-center">
            <h1 class="text-2xl font-bold text-slate-800">SuperYes Review Portal</h1>
            <p class="text-slate-500 mt-2">Please sign in with your company email</p>
          </div>

          @if(error()) {
            <div class="bg-red-50 text-red-800 p-3 rounded-md flex items-center mb-4 text-sm" role="alert">
              <svg class="h-5 w-5 text-red-500 mr-3 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.293 7.293a1 1 0 011.414 0L10 8.586l1.293-1.293a1 1 0 111.414 1.414L11.414 10l1.293 1.293a1 1 0 01-1.414 1.414L10 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L8.586 10 7.293 8.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
              <span>{{ error() }}</span>
            </div>
          }

          <div class="space-y-6">
            <form (ngSubmit)="handleSendOtp()">
              <div class="space-y-4">
                  <div>
                    <label for="email" class="sr-only">Email address</label>
                    <input 
                      type="email" 
                      id="email" 
                      name="email"
                      [(ngModel)]="email"
                      required
                      placeholder="Enter your cordic.com email"
                      class="block w-full rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                  </div>

                  <button 
                    type="submit"
                    [disabled]="loading() || !email() || cooldownSeconds() > 0"
                    class="w-full bg-slate-700 hover:bg-slate-800 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-150 ease-in-out disabled:bg-slate-400 flex items-center justify-center">
                    @if(loading() && email()) {
                      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <span>Sending code...</span>
                    } @else if (cooldownSeconds() > 0) {
                      <span>Resend code in {{ cooldownSeconds() }}s</span>
                    } @else {
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m21.75 0-9 6.75L2.25 6.75m21.75 0-9 6.75m-9-6.75h18" />
                      </svg>
                      <span>Sign in with Email</span>
                    }
                  </button>
              </div>
            </form>
          </div>
        }
      </div>
    }

  </div>
</div>
